window.test = {};

function init() {
    if ($('#mailTemplates').length > 0) {
        /*
         * Mailoptionen (container rechts und links) verstecken
         * Sobald eine Vorlage bearbeitet wird werden die Optionen eingeblendet
         */
        $('.sticky').hide();

        /**
         * Mailvorlagen
         */
        var container_new = $('.template-new');
        /*
         * Neue Vorlage erstellen
         */
        $('.mail-add').click(function (event) {
            if (container_new.createNew === true) {
                return;
            }
            container_new.container = container_new;
            container_new.action = 'create';
            $('.sticky').show();
            var clone = $('#mail-template').clone();
            container_new.append(clone);
            container_new.createNew = true;
            container_new.show();
            clone.show();
            $('#mail-cancel').off('click');
            $('#mail-cancel').on('click', function (event) {
                container_new.html('');
                container_new.hide();
                $('.sticky').hide();
                container_new.createNew = false;
            });
            var dropZone = clone.find('.mailZone');
            registerDragnDrop(dropZone);
            clone[0].querySelector('.mailTitel').focus();
            clone[0].querySelector('button.save-template').addEventListener('click', function () {
                saveTemplate(false);
            });
            clone[0]
                .querySelector('button.cancel-save-template')
                .addEventListener('click', function () {
                    container_new.createNew = false;
                    container_new.html('');
                    container_new[0].style.display = 'none';
                });
        });

        document.querySelectorAll('.isSms').forEach(function (smsCheckBox) {
            smsCheckBox.addEventListener('change', function () {
                if (container_new.action == 'create') {
                    return;
                }
                /** @type {HTMLElement} sendButton*/
                var sendButtons =
                    this.closest('.mail-template-data').querySelectorAll('button.ok i');
                /** @type {HTMLDivElement} mailListRow*/
                var mailListRow = this.closest('.mail-template-data').previousElementSibling;
                var elList = Array.from(sendButtons);
                if (mailListRow && mailListRow.classList.contains('low')) {
                    elList.push(mailListRow.querySelector('.test-mail i'));
                }

                if (this.checked) {
                    elList.forEach(function (el) {
                        el.classList.remove('icon-mail');
                        el.classList.add('icon-telegram');
                        el.title = 'SMS-Vorlage';
                    });
                } else {
                    elList.forEach(function (el) {
                        el.classList.remove('icon-telegram');
                        el.classList.add('icon-mail');
                        el.title = 'Mail-Vorlage';
                    });
                }
            });
        });
        /*
         * Element entfernen/löschen
         */
        $('.cms-trash').droppable({
            placeholder: 'block-placeholder',
            over: function (event, ui) {
                $('.cms-trash').css('background-color', '#8796c1');
            },
            out: function (event, ui) {
                $('.cms-trash').css('background-color', '#e9ecf5');
            },
            drop: function (event, ui) {
                $('.cms-trash').css('background-color', '#e9ecf5');
                ui.draggable.remove();
            }
        });

        function registerDragnDrop(dropZone) {
            $('.cmsDrag').draggable({
                helper: function (e) {
                    return $(
                        '<div class="cms-new-drag" data-type="' +
                            $(e.target).attr('data-type') +
                            '" data-id="' +
                            $(e.target).attr('data-id') +
                            '">'
                    )
                        .addClass('block')
                        .text($(e.target).text());
                },
                connectToSortable: dropZone
            });

            dropZone.sortable({
                handle: '.cms-block-picker',
                placeholder: 'block-placeholder',
                helper: function (event, ui) {
                    $(ui).css({
                        'z-index': '999',
                        'max-width': '20em',
                        'max-height': '10em',
                        overflow: 'hidden',
                        'background-color': '#fff'
                    });
                    return ui;
                },
                cursorAt: {
                    top: 10,
                    left: 50
                },

                over: function (event, ui) {
                    $(ui.item).css('max-width', '');
                },
                out: function (event, ui) {
                    $(ui).css('max-width', '20em');
                },
                stop: function (event, ui) {
                    //$(ui).css('max-width', '');
                    $(ui).css({
                        'max-width': '',
                        'max-height': '',
                        overflow: '',
                        'background-color': ''
                    });
                },
                remove: function (event, ui) {
                    this.refreshPositions();
                },
                receive: function (event, ui) {
                    var newIndex = $(this).data('ui-sortable').currentItem.index();
                },
                update: function (event, ui) {
                    $(ui).css('max-width', '');
                    var dropTitle = ui.item.context.textContent;
                    if ($(ui.item).hasClass('block')) {
                        ui.item.removeClass('block');
                        ui.item.removeClass('cms-new-drag');
                        ui.item.addClass('cms-block');
                        ui.item[0].style = '';
                        ui.item.html(
                            '<div style="text-align:center"><img src="/img/loader.gif"	alt="Lade Daten	..." />'
                        );
                        var dataId = ui.item.attr('data-id');
                        var dataType = ui.item.attr('data-type');
                        $.ajax({
                            type: 'POST',
                            url: '/Handler/HvD/NewItem',
                            data: {
                                id: dataId,
                                type: dataType,
                                isMail: true
                            }
                        }).done(function (data, state, jqxhr) {
                            ui.item.html(
                                '<div class="cms-block-picker" title="' +
                                    dropTitle +
                                    '"></div><div class="container-fluid block">' +
                                    data +
                                    '</div>'
                            );
                            ui.item.tooltip();
                            ui.item.css({
                                width: '',
                                height: ''
                            });

                            if ($(ui.item).find('.pegel-dropdown')) {
                                registerPegelDropDown($(ui.item).find('.pegel-dropdown'));
                            }
                            var textBaustein = $(ui.item).find('.dlgTextbausteine');
                            if (textBaustein.length > 0) {
                                initTextbausteine(ui.item);
                            }
                            var editor = $(ui.item).find('div.ckedit');
                            document
                                .querySelectorAll('.mailZone .no-mailzone')
                                .forEach(function (div) {
                                    div.remove();
                                });
                            if (editor.length > 0) {
                                CKEDITOR.disableAutoInline = true;
                                if (!CKEDITOR.instances[editor[0]]) {
                                    window.CKEDITOR.inline(editor[0]);
                                }
                            }
                        });
                    }
                }
            });
        }
        /*
         * Dragndrop
         */

        /*
         * Mailvorlage speichern
         */
        function saveTemplate(copy) {
            /*
                VorlagenId (0 für neu)
                Titel
                Betreff
                Templates
                    daten
            */

            // console.log("save mail");
            var mailId = 0;
            var mailTitel = '';
            var mailBetreff = '';
            var container = container_new;
            var async = true;
            var sms = 0;
            if (container_new.createNew) {
                mailTitel = container_new.find('.mailTitel').val().toString();
                mailBetreff = container_new.find('.mailBetreff').val().toString();
            } else {
                container = container_new.container;
                mailId = parseInt(container.attr('data-id'));
                mailTitel = container.find('.mailTitel').val();
                mailBetreff = container.find('.mailBetreff').val().toString();
            }
            sms = container.find('input.isSms')[0].checked ? 1 : 0;
            if (copy) {
                // mailTitel = $('#copy-title').text();
                async = false;
            }
            var mailItems = new Array();
            var $items = container.find('.cms-block');
            for (var i = 0; i < $items.length; i++) {
                mailItems[i] = new Object();
                mailItems[i]['id'] = $($items[i]).attr('data-id');
                mailItems[i]['type'] = $($items[i]).attr('data-type');
                mailItems[i]['sort'] = (i + 1) * 10;
                mailItems[i]['data'] = new Array();

                var $data = $($items[i]).find('[data-name]');
                for (var n = 0; n < $data.length; n++) {
                    if (
                        $data[n].type !== 'checkbox' ||
                        ($data[n].type === 'checkbox' && $data[n].checked)
                    ) {
                        mailItems[i]['data'][n] = new Object();
                        mailItems[i]['data'][n]['fieldname'] = $($data[n]).attr('data-name');
                        if ($($data[n]).val()) {
                            mailItems[i]['data'][n]['fieldvalue'] = $($data[n]).val();
                        } else {
                            mailItems[i]['data'][n]['fieldvalue'] = $($data[n]).html();
                        }
                    }
                }
            }
            var saveData = {
                action: container_new.action,
                id: mailId,
                titel: mailTitel,
                betreff: mailBetreff,
                sms: sms,
                items: mailItems
            };
            if (sms) {
                // max length 160;
                var smsMaxLength = 160;
                var smsText = '';
                mailItems.forEach(function (item) {
                    item.data.forEach(function (dataItem) {
                        var dummyHtml = document.createElement('div');
                        dummyHtml.innerHTML = dataItem.fieldvalue;
                        smsText += dummyHtml.textContent;
                    });
                });
                if (smsText.length > smsMaxLength) {
                    tools.toast(
                        'Fehler',
                        'Maximale länge überschritten: ' + smsText.length + ' > ' + smsMaxLength
                    );
                    return false;
                }
            }
            $.ajax({
                type: 'POST',
                url: '/Handler/HvD/Mail',
                dataType: 'json',
                async: async,
                data: {
                    data: saveData
                }
            }).done(function (data) {
                if (async) {
                    tools.toast('Vorlage', "'" + mailTitel + "' gespeichert");
                }
                if (parseInt(data) > 0 && container_new.action == 'create') {
                    document.querySelector('#loader .content p').innerHTML =
                        'Bitte warten, Seite wird neu geladen';
                    $('#loader').show();
                    location.reload();
                }
            });
            return true;
        }
        $('#mail-save').click(saveTemplate);
        /*
         * Mailvorlage bearbeiten
         */
        $('.vorlage-edit').click(function (event) {
            var $editZone = $(this).parents(':eq(1)').next();
            if (!$editZone.is(':visible')) {
                container_new.createNew = false;
                container_new.container = $editZone;
                container_new.action = 'update';
                $editZone.show();
                $('.sticky').show();
                registerDragnDrop($editZone.find('.mailZone'));
            } else {
                $editZone.hide();
                $('.sticky').hide();
            }
        });

        /**
         * Wenn kopie dann sticky anzeigen
         **/
        if ($('#mail-copy-data').length > 0) {
            container_new.createNew = false;
            container_new.container = $('#mail-copy-data');
            container_new.action = 'update';
            $('.sticky').show();
            registerDragnDrop($('#mail-copy-data .mailZone'));
        }

        /*
         * Mailvorlage löschen
         */
        var dlgTemplateDel = $('#dlg-template-del').dialog({
            width: 260,
            height: 170,
            autoOpen: false,
            modal: true,
            buttons: [
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function (event) {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Löschen',
                    class: 'ok',
                    click: function (event) {
                        $.ajax({
                            type: 'POST',
                            url: '/Handler/HvD/Mail',
                            data: {
                                data: {
                                    action: 'del',
                                    id: dlgTemplateDel.templateId
                                }
                            }
                        }).done(function (data) {
                            if (data == 'ok') {
                                tools.toast(
                                    'Vorlage gelöscht',
                                    'Vorlage "<b>' + dlgTemplateDel.templateTitle + '</b>" gelöscht'
                                );
                                location.reload();
                            } else {
                                tools.toast(
                                    'Fehler',
                                    'Vorlage "<b>' +
                                        dlgTemplateDel.templateTitle +
                                        '</b>" NICHT gelöscht'
                                );
                            }
                        });
                    }
                }
            ]
        });
        $('#mailTemplates .icon-trash').click(function (event) {
            dlgTemplateDel.templateTitle = $(this).attr('data-title');
            dlgTemplateDel.templateId = $(this).attr('data-id');
            $('#dlg-template-del span.template-title').html(dlgTemplateDel.templateTitle);
            dlgTemplateDel.dialog('open');
        });

        registerPegelDropDown($('.pegel-dropdown'));

        /**
         * /Mailvorlagen
         */

        /**
         * Kopie erzeugen
         */
        $('.copy-mail').click(function (event) {
            // create copy from data-id
            $('#worker').show();
            $.ajax({
                type: 'POST',
                url: '/Handler/HvD/Mail',
                async: true,
                data: {
                    data: {
                        action: 'copy',
                        id: $(this).attr('data-id')
                    }
                }
            }).done(function (data) {
                tools.toast('Kopie erzeugt', 'Es wurde eine Kopie angelegt');
                location.reload();
            });
        });

        /**
         * Mailtest
         */
        $('.mail-action .test-mail').click(function (event) {
            // Diagramme rendern
            // Bilder exportieren
            // Diagramme in Mail durch Bilder erstezen
            if ($(this).hasClass('copy')) {
                // speichern, nur bei einer kopie!
                container_new.createNew = false;
                // container_new.container = $('#mail-copy-data');
                container_new.container = $(this.closest('.mail-template-data'));
                container_new.action = 'update';
                if (!saveTemplate(true)) {
                    return;
                }
            }
            var sms = 0;
            if (this.closest('.mail-template-data')) {
                sms = this.closest('.mail-template-data').querySelector('input.isSms').checked
                    ? 1
                    : 0;
            } else {
                sms = parseInt(this.dataset.sms);
            }

            // at work anzeigen und Seite sperren
            $('#worker-message').html('Testmail wird versendet.');
            $('#worker').show();
            $.ajax({
                type: 'POST',
                url: '/Handler/HvD/Mail',
                data: {
                    data: {
                        action: 'test',
                        id: $(this).attr('data-id'),
                        sms: sms
                    }
                }
            }).done(function (data) {
                $('#worker').hide();
                tools.toast('Test', 'Versendet an ' + data);
            });
        });
        /**
         * Mailversenden
         * - Dialog öffnen
         * - verteilerliste/n wählen
         * - Einzelne User wählen
         * - einzelne Mails eintragen
         */
        $('.mail-action .send-mail').click(function (event) {
            var mailId = $(this).attr('data-id');
            var isSms = this.closest('.mail-template-data').querySelector('.isSms').checked
                ? true
                : false;

            if (this.classList.contains('copy')) {
                // speichern, nur bei einer kopie!
                container_new.createNew = false;
                container_new.container = $('#mail-copy-data');
                container_new.action = 'update';
                if (!saveTemplate(true)) {
                    return;
                }
            }
            if (isSms) {
                document.getElementById('dlg-single-user').innerHTML =
                    'Handynummer/n<br />Mehrere mit Semikolon getrennt';
            } else {
                document.getElementById('dlg-single-user').innerHTML =
                    'Mailadresse/n<br />Mehrere mit Semikolon getrennt';
            }

            var dlgMailSend = $('#dlg-mail-send').dialog({
                width: 700,
                height: 436,
                autoOpen: false,
                modal: true,
                buttons: [
                    {
                        text: 'Abbrechen',
                        class: 'cancel',
                        click: function (event) {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Senden',
                        class: 'ok',
                        click: function (event) {
                            if (isSms) {
                                tools.toast('SMS', 'Der SMS-Versand wurde gestartet');
                                $('#worker-message').html('SMS werden versendet.');
                            } else {
                                tools.toast('Mail', 'Der Mailversand wurde gestartet');
                                $('#worker-message').html('Mails werden versendet.');
                            }

                            $('#worker').show();
                            $.ajax({
                                type: 'POST',
                                url: '/Handler/HvD/Mail',
                                data: {
                                    data: {
                                        action: 'send',
                                        id: mailId,
                                        sms: isSms,
                                        list: $(this).find('.drp-mailsend-list-multi').val(),
                                        usr: $(this).find('.drp-mailsend-users').val(),
                                        mail: $(this).find('.single-user').val()
                                    }
                                }
                            }).done(function (data) {
                                $('#worker').hide();
                                if (isSms) {
                                    tools.toast('SMS', 'SMS versendet<br />' + data);
                                } else {
                                    tools.toast('Mail', 'Mail versendet');
                                }
                            });
                        }
                    }
                ],
                close: function (event, ui) {
                    //$(dlgMailSend).find('.drp-mailsend-list').selectmenu('destroy');
                    $(dlgMailSend).find('.drp-mailsend-users').selectmenu('destroy');
                }
            });
            //$(dlgMailSend).find('.drp-mailsend-list').selectmenu({ width: '100%', height: '40' });
            $(dlgMailSend).find('.drp-mailsend-users').selectmenu({
                width: '100%'
            });
            dlgMailSend.dialog('open');
        });

        /**
         * Nutzerkreise
         */
        var url = '/Handler/HvD/Nutzerkreise';

        /**
         * Dialog Neue Nutzergruppe oder bearbeiten
         */
        var dlgNutzerkreis = $('#nutzerkreis-new').dialog({
            width: 700,
            height: 560,
            autoOpen: false,
            modal: true,
            buttons: [
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function (event) {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Speichern',
                    class: 'ok',
                    click: function (event) {
                        var title = dlgNutzerkreis.find('.title').val();
                        if (title !== '') {
                            var items = [];
                            var users = $('#users-right li');
                            users.each(function (i, el) {
                                el = $(el);
                                items.push(el.attr('data-id'));
                            });
                            var data = {
                                data: {
                                    action: dlgNutzerkreis.action,
                                    id: dlgNutzerkreis.kreisId,
                                    title: title,
                                    items: items
                                }
                            };
                            $.ajax({
                                type: 'POST',
                                url: url,
                                data: data
                            }).done(function (data) {
                                if (data != 'err') {
                                    // Liste erneuern
                                    // [{"id":1,"title":"test1"},{"id":2,"title":"test2"}]
                                    data = JSON.parse(data);
                                    var list = $('#nutzerKreise .list');
                                    list.html('');
                                    for (var i = 0; i < data.length; i++) {
                                        var $cloneItem = $('#nutzerKreise .row-item').clone();
                                        $cloneItem.find('.title').html(data[i].title);
                                        $cloneItem.find('.count').html(data[i].count);
                                        var mails = '';
                                        for (var n = 0; n < data[i].users.length; n++) {
                                            mails += data[i].users[n].mail;
                                            if (n + 1 < data[i].users.length) {
                                                mails += ',&nbsp;';
                                            }
                                        }
                                        $cloneItem.find('.mails').html(mails);
                                        $cloneItem
                                            .find('.nutzerkreis-edit')
                                            .attr('data-id', data[i].id);
                                        $cloneItem.removeClass('row-item');
                                        $cloneItem.show();
                                        list.append($cloneItem);
                                    }
                                    $('.nutzerkreis-edit').click(function (event) {
                                        openNutzerKreis(this);
                                    });
                                    dlgNutzerkreis.dialog('close');
                                    tools.toast('Nutzerkreis', title + ' gespeichert');
                                } else {
                                    alert('Beim speichern ist ein Fehler aufgetreten.');
                                }
                            });
                        } else {
                            alert('Bitte geben Sie eine Bezeichnung für die Nutzerliste an');
                        }
                    }
                }
            ]
        });

        // Öffnen
        $('.nutzerkreis-add, .nutzerkreis-edit').click(function (event) {
            openNutzerKreis(this);
        });

        function openNutzerKreis(el) {
            var id = $(el).attr('data-id');
            if (id) {
                dlgNutzerkreis.action = 'update';
                dlgNutzerkreis.kreisId = id;
                dlgNutzerkreis.dialog('option', 'title', 'Empfängerliste bearbeiten');
                dlgNutzerkreis.find('input.title').val($(el).parent().next().find('span').html());
                fillList(id);
            } else {
                dlgNutzerkreis.action = 'create';
                dlgNutzerkreis.kreisId = -1;
                dlgNutzerkreis.find('input.title').val('');
                dlgNutzerkreis.dialog('option', 'title', 'Empfängerlisten anlegen');
                fillList(0);
            }
            dlgNutzerkreis.dialog('open');
            $('.scroll-pane').jScrollPane({
                showArrows: true
            });
        }
        /**
         * Listen füllen
         */
        function fillList(id) {
            $('.mailAddress-add').off('click');
            $('.mailAddress-add').click(function (event) {
                if ($('#txtMail').isMail()) {
                    var item = $(
                        '<li data-id="' +
                            $('#txtMail').val() +
                            '"><i class="icon-right-dir"></i> ' +
                            $('#txtMail').val() +
                            '</li>'
                    );
                    $('#users-right').append(item);
                } else {
                    alert('wrong mail');
                }
            });
            $.ajax({
                type: 'POST',
                url: url,
                dataType: 'json',
                data: {
                    data: {
                        action: 'getUsers',
                        id: id
                    }
                }
            }).done(function (data) {
                console.log(data);
                /* Listen füllen */
                var lList = $('#users-left').html('');
                var rList = $('#users-right').html('');
                insertItems(data.left, lList);
                insertItems(data.right, rList);
                $('.scroll-pane').jScrollPane({
                    showArrows: true
                });
                function insertItems($list, $target) {
                    for (var el in $list) {
                        el = $list[el];
                        if (typeof el === 'function') {
                            continue;
                        }

                        var item = '';
                        if (el.nachname + el.vorname === '') {
                            item = $(
                                '<li data-id="' +
                                    el.mail +
                                    '" title="' +
                                    el.mail +
                                    '"><i class="icon-right-dir"></i> ' +
                                    el.mail +
                                    '</li>'
                            );
                        } else {
                            item = $(
                                '<li data-id="' +
                                    el.id +
                                    '" title="' +
                                    el.nachname +
                                    ', ' +
                                    el.vorname +
                                    '" ><i class="icon-right-dir"></i> ' +
                                    el.nachname +
                                    ', ' +
                                    el.vorname +
                                    '</li>'
                            );
                        }
                        $target.append(item);
                    }
                }
                /* Listen Filter */
                $('.txt-user-filter').keyup(function (event) {
                    filterList($(this).parent().next().find('ul'), $(this).val());
                });

                function filterList($list, value) {
                    var rx = new RegExp(value, 'i');
                    $list.find('li').each(function (i, el) {
                        el = $(el);
                        if (el.text().match(rx) != null) {
                            el.show();
                        } else {
                            el.hide();
                        }
                    });
                }
            });
        }

        /**
         * 2 Listen Sortierbar mit DragDrop
         */
        var oldList, newList, item;
        $('.sortable')
            .sortable({
                start: function (event, ui) {
                    item = ui.item;
                    newList = oldList = ui.item.parent();
                },
                change: function (event, ui) {
                    if (ui.sender) newList = ui.placeholder.parent();
                },
                connectWith: '.sortable'
            })
            .disableSelection();

        /*
         * Nutzerkreis löschen
         */
        var dlgNutzerkreisDel = $('#dlg-nutzerkreis-del').dialog({
            width: 260,
            height: 170,
            autoOpen: false,
            modal: true,
            buttons: [
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function (event) {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Löschen',
                    class: 'ok',
                    click: function (event) {
                        $.ajax({
                            type: 'POST',
                            url: '/Handler/HvD/Nutzerkreise',
                            data: {
                                data: {
                                    action: 'del',
                                    id: dlgNutzerkreisDel.kreisId
                                }
                            }
                        }).done(function (data) {
                            if (data == 'ok') {
                                tools.toast(
                                    'Nutzerkreis gelöscht',
                                    'Nutzerkreis "<b>' +
                                        dlgTemplateDel.templateTitle +
                                        '</b>" gelöscht'
                                );
                                location.reload();
                            } else {
                                tools.toast(
                                    'Fehler',
                                    'Nutzerkreis "<b>' +
                                        dlgTemplateDel.templateTitle +
                                        '</b>" NICHT gelöscht'
                                );
                            }
                        });
                    }
                }
            ]
        });
        $('#nutzerKreise .icon-trash').click(function (event) {
            console.debug($(this).attr('data-title'));
            dlgNutzerkreisDel.kreisTitle = $(this).attr('data-title');
            dlgNutzerkreisDel.kreisId = $(this).attr('data-id');
            $('#dlg-nutzerkreis-del span.template-title').html(dlgNutzerkreisDel.kreisTitle);
            dlgNutzerkreisDel.dialog('open');
        });

        /**
         * /Nutzerkreise
         */
    }
}
init();
